// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content056_wrapper__Lck1G","block":"Content056_block__DDgHi","title":"Content056_title__375ix","description":"Content056_description__0g1G3"};